export const SHOW_REQUEST_REASON = "SHOW_REQUEST_REASON";
export const SHOW_ADD_REQUEST_REASON = "SHOW_ADD_REQUEST_REASON";
export const GET_BRANCH_DETAILS = "GET_BRANCH_DETAILS";
export const GET_ITEM_DETAILS = "GET_ITEM_DETAILS";
export const GET_VEHICLE_DETAILS = "GET_VEHICLE_DETAILS";
export const GET_VALID_ASSET_DATA_PLANNED = "GET_VALID_ASSET_DATA_PLANNED";
export const SET_VALID_ASSET_DATA_PLANNED = "SET_VALID_ASSET_DATA_PLANNED";
export const SET_ASSET_VALIDATION_PLANNED_FLG =
  "SET_ASSET_VALIDATION_PLANNED_FLG";
export const GET_AUTO_COMPLETE_ASSET_PLANNED =
  "GET_AUTO_COMPLETE_ASSET_PLANNED";
export const SET_AUTO_COMPLETE_ASSET_PLANNED =
  "SET_AUTO_COMPLETE_ASSET_PLANNED";
export const SET_CATALOG_ITEM_DETAILS = "SET_CATALOG_ITEM_DETAILS";
export const GET_CATALOG_ITEM_DETAILS = "GET_CATALOG_ITEM_DETAILS";
export const GET_VEHICLE_TYPE_DROPDOWN = "GET_VEHICLE_TYPE_DROPDOWN";
export const SET_VEHICLE_TYPE_DROPDOWN = "SET_VEHICLE_TYPE_DROPDOWN";
export const SET_SELECTED_BRANCH_DETAILS = "SET_SELECTED_BRANCH_DETAILS";
export const SET_SELECTED_VEHICLE_TYPE = "SET_SELECTED_VEHICLE_TYPE";
export const SET_ORDER = "SET_ORDER";

export const SET_VEHICLE_TYPE_ID = "SET_VEHICLE_TYPE_ID";
export const GET_PREFERRED_MODEL_DROPDOWN = "GET_PREFERRED_MODEL_DROPDOWN";
export const SET_PREFERRED_MODEL_DROPDOWN = "SET_PREFERRED_MODEL_DROPDOWN";
export const GET_REASON_TYPES = "GET_REASON_TYPES";
export const SET_REASON_TYPES = "SET_REASON_TYPES";

export const SET_ITEM_DETAILS_GROWTH = "SET_ITEM_DETAILS_GROWTH";

export const SET_REASON_INFO = "SET_REASON_INFO";

export const SET_ADD_CLICK_FLG = "SET_ADD_CLICK_FLG";
export const GET_BRANCH = "GET_BRANCH";
export const SET_BRANCH = "SET_BRANCH";
export const SHOW_CATALOG_ITEM_DETAILS = "SHOW_CATALOG_ITEM_DETAILS";
export const SET_SELECTED_VEHICLES_COUNT = "SET_SELECTED_VEHICLES_COUNT";
export const SHOW_VEHICLE_REQUEST_FORM = "SHOW_VEHICLE_REQUEST_FORM";

export const GET_ADD_ORDER = "GET_ADD_ORDER";
export const SET_ADD_ORDER = "SET_ADD_ORDER";

export const SET_FILTERED_CATALOG_ITEM_VALUES =
  "SET_FILTERED_CATALOG_ITEM_VALUES";
export const SET_CREATE_ORDER_COMPLETE_FLAG = "SET_CREATE_ORDER_COMPLETE_FLAG";
export const SET_SPLICE_FLAG = "SET_SPLICE_FLAG";

export const SET_CATALOG_ACTIVE_STEPPER_FLAG = "SET_CATALOG_ACTIVE_STEPPER_FLAG";

export const GET_UPLOADED_BLOB_URL_LIST = "GET_UPLOADED_BLOB_URL_LIST";
export const SET_UPLOADED_BLOB_URL_LIST = "SET_UPLOADED_BLOB_URL_LIST";
export const SET_UPLOAD_FILES_COMPLETE = "SET_UPLOAD_FILES_COMPLETE";

export const GET_ASSET_TYPES = "GET_ASSET_TYPES";
export const SET_ASSET_TYPES = "SET_ASSET_TYPES";

export const GET_EQUIPMENT_DROPDOWN = "GET_EQUIPMENT_DROPDOWN";
export const SET_EQUIPMENT_DROPDOWN = "SET_EQUIPMENT_DROPDOWN";
export const GET_SEATINGCAPACITY_DROPDOWN = "GET_SEATINGCAPACITY_DROPDOWN";
export const SET_SEATINGCAPACITY_DROPDOWN = "SET_SEATINGCAPACITY_DROPDOWN";
export const GET_UTILITYMANUFACTURE_DROPDOWN =
  "GET_UTILITYMANUFACTURE_DROPDOWN";
export const SET_UTILITYMANUFACTURE_DROPDOWN =
  "SET_UTILITYMANUFACTURE_DROPDOWN";
export const GET_UTILITYENCLOSEDCAB_DROPDOWN =
  "GET_UTILITYENCLOSEDCAB_DROPDOWN";
export const SET_UTILITYENCLOSEDCAB_DROPDOWN =
  "SET_UTILITYENCLOSEDCAB_DROPDOWN";
export const GET_UTILITYCAPACITY_DROPDOWN = "GET_UTILITYCAPACITY_DROPDOWN";
export const SET_UTILITYCAPACITY_DROPDOWN = "SET_UTILITYCAPACITY_DROPDOWN";
export const GET_TRAILERMANUFACTURE_DROPDOWN =
  "GET_TRAILERMANUFACTURE_DROPDOWN";
export const SET_TRAILERMANUFACTURE_DROPDOWN =
  "SET_TRAILERMANUFACTURE_DROPDOWN";
export const GET_TRAILERSTYLE_DROPDOWN = "GET_TRAILERSTYLE_DROPDOWN";
export const SET_TRAILERSTYLE_DROPDOWN = "SET_TRAILERSTYLE_DROPDOWN";
export const GET_TRAILERLENGTH_DROPDOWN = "GET_TRAILERLENGTH_DROPDOWN";
export const SET_TRAILERLENGTH_DROPDOWN = "SET_TRAILERLENGTH_DROPDOWN";
export const GET_TRAILERFUELTANK_DROPDOWN = "GET_TRAILERFUELTANK_DROPDOWN";
export const SET_TRAILERFUELTANK_DROPDOWN = "SET_TRAILERFUELTANK_DROPDOWN";
export const GET_TRAILERCHARGINGSTATION_DROPDOWN =
  "GET_TRAILERCHARGINGSTATION_DROPDOWN";
export const SET_TRAILERCHARGINGSTATION_DROPDOWN =
  "SET_TRAILERCHARGINGSTATION_DROPDOWN";
export const GET_SNOWMANUFACTURE_DROPDOWN = "GET_SNOWMANUFACTURE_DROPDOWN";
export const SET_SNOWMANUFACTURE_DROPDOWN = "SET_SNOWMANUFACTURE_DROPDOWN";
export const GET_SNOWCATEGORY_DROPDOWN = "GET_SNOWCATEGORY_DROPDOWN";
export const SET_SNOWCATEGORY_DROPDOWN = "SET_SNOWCATEGORY_DROPDOWN";
export const GET_SNOWSIZE_DROPDOWN = "GET_SNOWSIZE_DROPDOWN";
export const SET_SNOWSIZE_DROPDOWN = "SET_SNOWSIZE_DROPDOWN";
export const GET_SNOWTYPE_DROPDOWN = "GET_SNOWTYPE_DROPDOWN";
export const SET_SNOWTYPE_DROPDOWN = "SET_SNOWTYPE_DROPDOWN";
export const GET_SNOWPARENTVEHICLE_DROPDOWN = "GET_SNOWPARENTVEHICLE_DROPDOWN";
export const GET_DEVELOPMENTCATEGORY_DROPDOWN =
  "GET_DEVELOPMENTCATEGORY_DROPDOWN";
export const SET_DEVELOPMENTCATEGORY_DROPDOWN =
  "SET_DEVELOPMENTCATEGORY_DROPDOWN";
export const GET_DEVELOPMENTMANUFACTURE_DROPDOWN =
  "GET_DEVELOPMENTMANUFACTURE_DROPDOWN";
export const SET_DEVELOPMENTMANUFACTURE_DROPDOWN =
  "SET_DEVELOPMENTMANUFACTURE_DROPDOWN";

export const GET_TREEMANUFACTURE_DROPDOWN = "GET_TREEMANUFACTURE_DROPDOWN";
export const SET_TREEMANUFACTURE_DROPDOWN = "SET_TREEMANUFACTURE_DROPDOWN";
export const GET_TREEEQUIPMENTTYPE_DROPDOWN = "GET_TREEEQUIPMENTTYPE_DROPDOWN";
export const SET_TREEEQUIPMENTTYPE_DROPDOWN = "SET_TREEEQUIPMENTTYPE_DROPDOWN";
export const GET_TREEHORSEPOWER_DROPDOWN = "GET_TREEHORSEPOWER_DROPDOWN";
export const SET_TREEHORSEPOWER_DROPDOWN = "SET_TREEHORSEPOWER_DROPDOWN";
export const GET_TREEFUELTYPE_DROPDOWN = "GET_TREEFUELTYPE_DROPDOWN";
export const SET_TREEFUELTYPE_DROPDOWN = "SET_TREEFUELTYPE_DROPDOWN";

export const GET_STANDARDCATEGORY_DROPDOWN = "GET_STANDARDCATEGORY_DROPDOWN";
export const SET_STANDARDCATEGORY_DROPDOWN = "SET_STANDARDCATEGORY_DROPDOWN";
export const GET_STANDARDMANUFACTURE_DROPDOWN =
  "GET_STANDARDMANUFACTURE_DROPDOWN";
export const SET_STANDARDMANUFACTURE_DROPDOWN =
  "SET_STANDARDMANUFACTURE_DROPDOWN";
export const SET_VEHICLETYPE_FLAG = "SET_VEHICLETYPE_FLAG";

export const SET_VEHICLE_HISTORY_CARD_FLAG = "SET_VEHICLE_HISTORY_CARD_FLAG";

export const SET_SELECT_FLAG = "SET_SELECT_FLAG";
export const SET_UPLOADED_ATTACHMENT_DETAILS =
  "SET_UPLOADED_ATTACHMENT_DETAILS";
export const GET_STATE_AVAILABILITY = "GET_STATE_AVAILABILITY";
export const SET_STATE_AVAILABILITY = "SET_STATE_AVAILABILITY";
export const GET_PROGRAM_STATUS = "GET_PROGRAM_STATUS";
export const SET_PROGRAM_STATUS = "SET_PROGRAM_STATUS";
export const GET_ANNUAL_HOURS = "GET_ANNUAL_HOURS";
export const SET_ANNUAL_HOURS = "SET_ANNUAL_HOURS";
export const GET_DECK_SIZES = "GET_DECK_SIZES";
export const SET_DECK_SIZES = "SET_DECK_SIZES";
export const GET_DECK_TYPE = "GET_DECK_TYPE";
export const SET_DECK_TYPE = "SET_DECK_TYPE";
export const GET_AUTONOMOUS = "GET_AUTONOMOUS";
export const SET_AUTONOMOUS = "SET_AUTONOMOUS";
export const GET_MANUFACTURER_DROPDOWN = "GET_MANUFACTURER_DROPDOWN";
export const SET_MANUFACTURER_DROPDOWN = "SET_MANUFACTURER_DROPDOWN";
export const GET_CATEGORY_DROPDOWN = "GET_CATEGORY_DROPDOWN";
export const SET_CATEGORY_DROPDOWN = "SET_CATEGORY_DROPDOWN";
export const SET_EDIT_CLICK_FLG = "SET_EDIT_CLICK_FLG";
export const GET_EDIT_VEHICLE_INDEX = "SET_EDIT_VEHICLE_INDEX";
export const SET_EDIT_VEHICLE_INDEX = "SET_EDIT_VEHICLE_INDEX";
export const SET_SEARCH_ERROR = "SET_SEARCH_ERROR";
export const SET_ASSET_TYPE_ID = "SET_ASSET_TYPE_ID";
export const SET_ASSET_TYPE_TEXT = "SET_ASSET_TYPE_TEXT";
export const SET_NEXT_FLAG = "SET_NEXT_FLAG";
export const SET_EDIT_REASON_VALUE = "SET_EDIT_REASON_VALUE";
export const SET_CART_NAV = "SET_CART_NAV";
export const SET_HEADER_NAV = "SET_HEADER_NAV";
export const SET_IS_SAVE = "SET_IS_SAVE";
export const SET_ORDER_ID = "SET_ORDER_ID";
export const SET_ACTIVE_HEADER = 'SET_ACTIVE_HEADER';
export const SET_CLICK_PREVIOUS = 'SET_CLICK_PREVIOUS';
export const SET_GRAND_TOTAL = 'SET_GRAND_TOTAL'
export const GET_REASONSTATUS_DROPDOWN = "GET_REASONSTATUS_DROPDOWN";
export const SET_REASONSTATUS_DROPDOWN = "SET_REASONSTATUS_DROPDOWN";
export const GET_REASONCONDITION_DROPDOWN = "GET_REASONCONDITION_DROPDOWN";
export const SET_REASONCONDITION_DROPDOWN = "SET_REASONCONDITION_DROPDOWN";
export const GET_DROPDOWNS_BY_SUBTYPE = "GET_DROPDOWNS_BY_SUBTYPE";
export const SET_DROPDOWNS_BY_SUBTYPE = "SET_DROPDOWNS_BY_SUBTYPE";
export const APPEND_DROPDOWN_DATA = "APPEND_DROPDOWN_DATA";
export const SET_BRANCH_CHANGE_FLAG = "SET_BRANCH_CHANGE_FLAG"
export const SET_ADD_REASON_FLAG = "SET_ADD_REASON_FLAG"

export const REQUEST_COST_CENTER = "REQUEST_COST_CENTER"
export const SUCCESS_COST_CENTER = "SUCCESS_COST_CENTER"

export const SET_SELECTED_REASON_TYPE = 'SET_SELECTED_REASON_TYPE'

export const SET_IS_REFRESH_REASON = 'SET_IS_REFRESH_REASON'